import { Platform } from 'react-native';

// "Tanah & Langit" (Earth & Sky) — timeless agricultural enterprise palette
export const PADIPRO = {
  bg: '#F5F3EE',              // warm parchment
  surface: '#FFFFFF',
  surfaceStrong: '#FFFFFF',
  surfaceSunken: '#EFEBE1',   // recessed panels / inputs

  border: '#E2DCC9',          // warm greige
  borderStrong: '#D3CBB4',

  text: '#1C2B22',            // near-black warm green
  textStrong: '#12201A',
  muted: '#6E7A6E',
  mutedSoft: '#93998A',

  primary: '#1B4332',         // deep forest green
  primaryDark: '#12301F',
  primarySoft: '#E7EEE7',
  primarySoftStrong: '#D3E1D3',

  gold: '#A67C00',            // harvest gold — accents & highlights only
  goldSoft: '#F7ECD1',
  goldDeep: '#7A5A00',

  warning: '#9A6508',
  warningSoft: '#FBF1DD',
  danger: '#9F2138',
  dangerSoft: '#FBEAEC',
  sky: '#25708F',
  skySoft: '#E7F1F4',
};

export const SPACE = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 };
export const RADIUS = { sm: 8, md: 12, lg: 16, xl: 20, pill: 999 };

export const padiproShadow = Platform.select({
  ios: {
    shadowColor: '#10291b',
    shadowOpacity: 0.08,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 3 },
  },
  android: { elevation: 2 },
  default: {},
});

export const padiproShadowMd = Platform.select({
  ios: {
    shadowColor: '#10291b',
    shadowOpacity: 0.1,
    shadowRadius: 14,
    shadowOffset: { width: 0, height: 6 },
  },
  android: { elevation: 4 },
  default: {},
});

export const padiproShadowLg = Platform.select({
  ios: {
    shadowColor: '#0b1f14',
    shadowOpacity: 0.16,
    shadowRadius: 22,
    shadowOffset: { width: 0, height: 10 },
  },
  android: { elevation: 8 },
  default: {},
});
